import { render, staticRenderFns } from "./MaintenanceHistoryTable.vue?vue&type=template&id=d5589f32&scoped=true&"
import script from "./MaintenanceHistoryTable.vue?vue&type=script&lang=js&"
export * from "./MaintenanceHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceHistoryTable.vue?vue&type=style&index=0&id=d5589f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5589f32",
  null
  
)

/* custom blocks */
import block0 from "./MaintenanceHistoryTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports